import React from 'react';

const EmptyStateImage = () => (
    <svg
        width="670"
        height="169"
        viewBox="0 0 581 169"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginRight: '150px' }}
    >
        <path
            d="M312 48.4229C317.911 46.6778 324.241 47.5401 330.265 48.817C336.288 50.0939 342.314 51.782 348.465 51.6542C352.355 51.573 356.19 50.7656 360.038 50.1785C360.697 50.0782 361.412 49.994 361.991 50.3302C362.495 50.6227 362.798 51.1905 362.923 51.7694C363.204 53.0685 362.685 54.447 361.832 55.4515C360.979 56.4559 359.868 57.234 358.664 57.7339C351.792 60.584 344.848 60.9741 337.327 59.869"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M358.366 50.4399C359.395 49.7211 360.098 48.1583 359.989 46.8263C359.88 45.4943 359.051 44.2633 357.922 43.7565C356.708 43.2112 355.335 43.486 354.042 43.7253C339.542 46.4088 324.701 43.5419 310 43.9493"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M326 44.4401C329.321 42.6722 331.828 41.4808 335.105 39.6333C337.571 38.2427 340.068 36.7603 341.854 34.568C342.751 33.4686 343.447 31.8646 342.653 30.6888C341.722 29.3083 339.622 29.6577 338.043 30.1952C330.899 32.6283 323.961 35.6921 316.664 37.6212C309.368 39.5503 301.527 40.2971 294.324 38.0476C285.138 35.1795 276.863 28.2958 268.149 24.0852C235.773 8.44184 208.257 4.38249 173.5 9.04433C143.643 13.0489 130.628 16.0414 115.291 18.1137C106.58 19.2908 100.239 16.1889 98.5376 13.3132C96.9058 10.5546 96.6772 4.47917 105.861 4.00749C109.178 3.83714 119.092 6.5609 119.092 13.3132C119.092 22.4511 111.195 27.5043 93.0352 30.6888C53.5039 37.6212 35.1191 5.8073 4 9.04433"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M337.5 30.6732C337.5 31.4468 337.598 32.2382 337.947 32.801C338.301 33.3703 338.808 33.7405 339.407 33.9518C340.29 34.2631 341.456 34.1819 342.23 32.801C343.003 31.4201 341.88 30.028 341.787 30.1046"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M352 44.6601C352.284 45.1883 352.619 45.6938 353.001 46.1695C353.35 46.6052 353.757 47.0283 354.3 47.2527C355.061 47.5679 355.959 47.4393 356.756 47.2035C357.431 47.0043 358.103 46.7165 358.551 46.2214C359 45.7264 359.168 44.9832 358.795 44.4399"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M354.98 51.3022C355.448 52.1392 356.484 53.9768 357.707 54.2715C358.929 54.5664 360.336 54.47 361.451 54.015C362.276 53.6788 362.968 53.1027 363 52.4399"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M329.658 81.4404C329.412 80.6359 329.219 79.8116 329.08 78.9761C328.96 78.2514 329.316 77.7957 329.658 77.1667C329.929 76.6668 330.382 75.936 330.93 75.936C332.317 75.936 332.757 76.4723 333.642 77.1667"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M313.904 54.5217C318.219 53.8707 322.63 53.2207 326.924 54C331.218 54.7793 335.45 57.2637 337.145 61.269C338.384 64.1953 338.127 67.5813 337.089 70.584C336.051 73.5863 334.288 76.2803 332.513 78.918C331.703 80.1207 330.746 81.4163 329.322 81.71C327.488 82.088 325.697 80.494 325.246 78.683C324.796 76.872 325.348 74.969 326.043 73.236C326.737 71.5027 327.588 69.7877 327.762 67.93C327.931 66.123 327.311 64.116 325.76 63.1633C324.845 62.6017 323.734 62.4707 322.66 62.4107C315.652 62.019 307.905 64.6723 304.636 70.8583"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M244.83 75.9357L239.186 152.341C239.186 152.341 415.567 160.309 485.5 158.743C502.352 158.365 566 152.341 566 152.341L570.248 84.9401C570.248 84.9401 371.991 70.8849 244.83 75.9357Z"
            fill="#BDE0F8"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M254 83.1416C254 83.1416 305.433 86.4401 342.5 86.4401C379.567 86.4401 434 87.877 434 87.877V150.156C434 150.156 376.829 152.341 346.118 152.341C315.406 152.341 254 150.156 254 150.156V83.1416Z"
            fill="#51B6FF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M439 87.4263C439 87.4263 468.113 87.2549 488.5 87.2549C508.887 87.2549 538 87.2549 538 87.2549V150.255C538 150.255 505.391 150.255 488.5 150.255C471.609 150.255 439 150.255 439 150.255V87.4263Z"
            fill="#51B6FF"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M304.528 69.9645C362.363 70.2307 425.743 72.6005 476.699 75.039C505.457 76.4152 530.256 77.8133 547.865 78.8672C556.67 79.3942 563.677 79.8352 568.483 80.1444C570.886 80.299 572.738 80.4207 573.99 80.5037C574.616 80.5452 575.092 80.577 575.411 80.5985L575.427 80.5995V161.072L575.111 161.081L572.832 161.15C570.86 161.21 568.024 161.295 564.568 161.399C557.656 161.606 548.265 161.886 538.347 162.178C518.511 162.763 496.571 163.394 488.147 163.583C453.192 164.366 388.412 163.734 332.362 162.907C304.339 162.494 278.501 162.031 259.669 161.672C250.253 161.492 242.588 161.339 237.278 161.23C234.622 161.175 232.556 161.132 231.153 161.103L229.556 161.069L229.523 161.068L233.687 70.9785C242.58 70.6292 251.903 70.3759 261.553 70.2069C260.724 69.8821 259.899 69.5638 259.079 69.252C250.13 69.4231 241.473 69.6684 233.189 69.9974C232.93 70.0077 232.722 70.2147 232.71 70.4739L228.501 161.534C228.494 161.669 228.543 161.8 228.635 161.898C228.727 161.997 228.854 162.054 228.989 162.057L229 161.557C228.989 162.057 228.99 162.057 228.991 162.057L228.998 162.057L229.024 162.058L229.127 162.06L229.534 162.069L231.132 162.103C232.535 162.132 234.602 162.175 237.257 162.23C242.568 162.339 250.233 162.492 259.65 162.672C278.483 163.031 304.322 163.494 332.347 163.907C388.393 164.734 453.192 165.366 488.17 164.582C496.598 164.394 518.542 163.762 538.377 163.178C548.295 162.886 557.686 162.606 564.598 162.398C568.054 162.295 570.89 162.209 572.862 162.15L575.141 162.081L575.738 162.063L575.89 162.058L575.929 162.057L575.939 162.057L575.941 162.057C575.942 162.057 575.942 162.057 575.927 161.557L575.942 162.057C576.212 162.049 576.427 161.827 576.427 161.557V80.1322C576.427 79.8692 576.223 79.6512 575.961 79.6333L575.927 80.1322C575.961 79.6333 575.96 79.6333 575.959 79.6332L575.953 79.6328L575.93 79.6312L575.839 79.6251L575.478 79.6007C575.159 79.5792 574.683 79.5474 574.056 79.5059C572.804 79.4228 570.951 79.3011 568.547 79.1465C563.74 78.8372 556.731 78.3961 547.925 77.869C530.312 76.8149 505.509 75.4166 476.747 74.0402C426.018 71.6125 362.967 69.2525 305.325 68.9683L304.528 69.9645Z"
            fill="#402451"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M260.898 91.0601L259 146.568C259 146.568 350.633 149.225 384.498 148.208C392.658 147.963 427 146.568 427 146.568V93.6964C427 93.6964 322.594 91.0601 260.898 91.0601Z"
            stroke="#402451"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="6"
        />
        <path d="M485.5 118.94H496.5" stroke="#402451" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M491 113.357L490.5 124.49" stroke="#402451" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M350.5 118.94H339.5" stroke="#402451" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M345.5 113.621V124.49" stroke="#402451" strokeLinecap="round" strokeLinejoin="round" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M444 93.1766V146.407C444 146.407 473.868 146.407 491.887 146.407C515.102 146.407 533 146.407 533 146.407V91.4072C533 91.4072 513.457 91.4072 488.5 91.4072C473.574 91.4072 450.707 93.1766 444 93.1766Z"
            stroke="#402451"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="6"
        />
        <path
            d="M305.81 69.0511C304.036 70.9973 303.17 75.2407 304.495 76.9274C305.647 78.3927 307.702 78.7231 309.556 78.9461C313.43 79.4121 317.304 79.8777 321.178 80.3434C322.779 80.5357 324.454 80.7561 325.767 81.6871C327.081 82.6181 327.861 84.5061 327.028 85.8804C326.379 86.9497 324.997 87.3587 323.743 87.3134C322.49 87.2681 321.277 86.8657 320.033 86.7097C315.342 86.1227 310.88 89.0441 306.155 89.1754C302.25 89.2844 298.571 87.4894 295.127 85.6534C232.78 52.4154 193.996 55.4967 151 69.4401"
            stroke="#402451"
            strokeLinecap="round"
        />
        <path
            d="M321 86.2031C320.998 85.3905 321.485 84.6693 322.062 84.1879C322.863 83.5201 323.958 83.1983 324.868 83.6499C325.778 84.1016 326.318 85.4819 325.795 86.4399"
            stroke="#402451"
            strokeLinecap="round"
        />
    </svg>
);

export default EmptyStateImage;
